import { ReactNode } from "react";

import styles from "@components/cards/Card.module.css";
import { Colors } from "@utils/colorUtils";
import { isMobileWeb, isNativeApp } from "@utils/platformUtils";

type Props = {
  active?: boolean;
  background?: Extract<Colors, "gray-50" | "gray-100" | "primary-300" | "primary-100" | "danger-300">;
  border?: "danger-300";
  boxShadow?: boolean;
  children: ReactNode;
  hover?: "none" | "purple" | "normal";
  inactive?: boolean;
  padding?: "small" | "normal" | "none" | "large";
};

const BasicCard = ({
  active = false,
  background,
  border,
  boxShadow = true,
  children,
  hover = "normal",
  inactive = false,
  padding = "normal"
}: Props) => {
  const isMobile = isMobileWeb() || isNativeApp();
  const wrapperStyles = [styles.card];
  if (!boxShadow) {
    wrapperStyles.push(styles.noBoxShadow);
  }

  if (padding === "small") {
    wrapperStyles.push(styles.cardSmallPadding);
  } else if (padding === "large") {
    wrapperStyles.push(styles.cardLargePadding);
  } else if (padding === "none") {
    wrapperStyles.push(styles.cardNoPadding);
  }

  if (background) {
    // TODO convert this to ionic with the card component
    wrapperStyles.push(styles[background]);
  }

  if (!isMobile) {
    if (hover === "normal") {
      wrapperStyles.push(styles.cardHover);
    } else if (hover === "purple") {
      wrapperStyles.push(styles.cardPurpleHover);
    }
  }

  if (inactive) {
    wrapperStyles.push(styles.cardInactive);
  }

  if (active) {
    wrapperStyles.push(styles.cardActive);
  }

  if (border) {
    wrapperStyles.push(styles[`${border}Border`]);
  }

  return <div className={wrapperStyles.join(" ")}>{children}</div>;
};

export default BasicCard;
